import { createContext, useContext } from 'react';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { INavigationConfig } from '~/src/dash/views/common';

interface IChannelsContext {
  cfg: INavigationConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  forceUpdate: (tabIndex: number) => void;
}

export const ChannelsContext = createContext({} as IChannelsContext);
export const useChannelsStore = (): IChannelsContext => useContext(ChannelsContext);
